import React from "react";
import { Grid, Box } from "@mui/material";
import CheckCircle from "@mui/icons-material/Check";

const USPItem = ({ text }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        marginBottom: "0",
      }}
    >
      <CheckCircle
        sx={{
          fontSize: { xs: "1.9rem", md: "1.9rem" },
          color: "rgb(186 175 255)",
          flexShrink: 0,
        }}
      />
      <Box
        component="span"
        sx={{
          fontSize: { xs: "1rem", md: "1rem" },
          lineHeight: "1.4",
          fontWeight: "500",
          color: "#e5e5e5",
          whiteSpace: { xs: "normal", sm: "nowrap" },
        }}
      >
        {text}
      </Box>
    </Box>
  );
};

const USPSection = () => {
  const uspPoints = [
    "Bedöm elevtexter med AI",
    "Följer EU:s AI-förordning ",
    "Följer Skolverkets läroplan",
    "GDPR-säker plattform",
    "Skapa egna matriser",
    "Anpassa bedömningsstil",
  ];

  return (
    <Box
      sx={{
        marginTop: { xs: "50px", md: "42px" },
        marginBottom: { xs: "0px", md: "32px" },
        width: { xs: "74%", md: "100%" },
        maxWidth: "601px",
        margin: "0 auto",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Grid container spacing={{ xs: 2, sm: 3 }} justifyContent="center">
        {uspPoints.map((point, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <USPItem text={point} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default USPSection;
